import { render, staticRenderFns } from "./areaDetail.vue?vue&type=template&id=2043e008&scoped=true"
import script from "./areaDetail.vue?vue&type=script&lang=js"
export * from "./areaDetail.vue?vue&type=script&lang=js"
import style0 from "./areaDetail.vue?vue&type=style&index=0&id=2043e008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043e008",
  null
  
)

export default component.exports